<template>
  <section class="row">
    <div style="width: 50%" class="q-pa-md q-mt-lg">
      <q-table
        flat
        style="height: 400px"
        table-header-class="bg-accent text-width-bold"
        title="Produtos Adicionados para contagem"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        class="tabela-tamanho-fixo"
        dense
        hide-pagination
        :rows-per-page-options="[0]"
        :filter="filtrar"
        row-key="name"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            v-model="filtrar"
            placeholder="Buscar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
          <q-btn
            class="q-ml-sm"
            @click="imprimir"
            color="primary"
            round
            icon="print"
          />
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              @click="confirmarRemover(props.row.id)"
              color="negative"
              size="sm"
              round
              icon="remove"
            />
          </q-td>
        </template>
        <template #body-cell-quantidade="props">
          <q-td>
            <div>
              <q-input
                dense
                outlined
                v-model="props.row.amount"
                label="Quantidade"
                :disable="inventario.status === 'Rascunho'"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
              <q-tooltip
                v-if="inventario.status === 'Rascunho'"
                anchor="bottom middle"
                self="bottom middle"
              >
                Finalize a seleção e inicie a contagem para preencher.
              </q-tooltip>
            </div>
          </q-td>
        </template>
        <template #body-cell-lote="props">
          <q-td>
            <div>
              <q-input
                style="min-width: 100px"
                :disable="
                  props.row.controla_lote == 0 ||
                  inventario.status === 'Rascunho'
                "
                dense
                label="Lote"
                outlined
                v-model="props.row.lote"
              />
              <q-tooltip
                v-if="inventario.status === 'Rascunho'"
                anchor="bottom middle"
                self="bottom middle"
              >
                Finalize a seleção e inicie a contagem para preencher.
              </q-tooltip>
            </div>
          </q-td>
        </template>
        <template #body-cell-validade="props">
          <q-td>
            <div>
              <q-input
                style="min-width: 100px"
                :disable="
                  props.row.controla_lote == 0 ||
                  inventario.status === 'Rascunho'
                "
                dense
                label="Validade"
                outlined
                mask="##/##/####"
                v-model="props.row.data_expiracao"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      v-if="inventario.status !== 'Rascunho'"
                      cover
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        :locale="myLocale"
                        mask="DD/MM/YYYY"
                        v-model="props.row.data_expiracao"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Fechar"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-tooltip
                v-if="inventario.status === 'Rascunho'"
                anchor="bottom middle"
                self="bottom middle"
              >
                Finalize a seleção e inicie a contagem para preencher.
              </q-tooltip>
            </div>
          </q-td>
        </template>
      </q-table>
      <q-btn
        v-if="inventario.status == 'Pendente'"
        style="width: 100%"
        @click="confirmarEnviarContados"
        color="positive"
        label="ENVIAR ITENS CONTADOS"
      />
    </div>
    <div style="width: 50%" class="q-pa-md q-mt-lg">
      <q-table
        style="height: 400px"
        flat
        dense
        table-header-class="bg-accent text-width-bold"
        title="Produtos Contados"
        :rows="rows2"
        :columns="columns2Computed"
        :loading="disable"
        hide-pagination
        :rows-per-page-options="[0]"
        :filter="filtrar2"
        row-key="name"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            v-model="filtrar2"
            placeholder="Buscar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
          <q-btn
            class="q-ml-sm"
            @click="imprimir2"
            color="primary"
            round
            icon="print"
          />
        </template>
      </q-table>
      <div class="row justify-end">
        <q-btn
          v-if="inventario.status == 'Rascunho'"
          style="width: 50%"
          icon="add"
          :disable="rows.length == 0"
          @click="confirmarContagem"
          color="positive"
          label="FINALIZAR SELEÇÃO E INICIAR CONTAGEM"
        />
        <q-btn
          v-if="inventario.status == 'Pendente'"
          class="row justify-end"
          style="width: 50%"
          icon="add"
          :disable="rows2.length == 0"
          @click="confirmarFinalizar"
          color="positive"
          label="FINALIZAR CONTAGEM E ENVIAR PARA APROVAÇÃO"
        />
      </div>

      <section
        class="column"
        v-if="
          inventario.status == 'Finalizado' &&
          inventario.origem_divergencia == 0
        "
      >
        <q-btn
          class="q-mt-sm"
          v-if="inventario.status == 'Finalizado'"
          style="width: 100%"
          @click="confirmarAprovarRecontar"
          color="positive"
          label="
                APROVAR E RECONTAR DIVERGENTES
              "
        />
        <q-btn
          class="q-mt-sm"
          v-if="inventario.status == 'Finalizado'"
          style="width: 100%"
          @click="confirmarAprovarSolicitar"
          color="positive"
          label="
                APROVAR E SOLICITAR APROVAÇÃO DE DIVERGENTES
              "
        />
      </section>

      <section
        class="column"
        v-if="
          inventario.status == 'Finalizado' &&
          inventario.origem_divergencia.length != 0
        "
      >
        <q-btn
          class="q-mt-sm"
          v-if="inventario.status == 'Finalizado'"
          style="width: 100%"
          @click="confirmarRecontar"
          color="positive"
          label="SOLICITAR RE CONTAGEM"
        />
        <q-btn
          class="q-mt-sm"
          v-if="inventario.status == 'Finalizado'"
          style="width: 100%"
          @click="confirmarAprovarDivergente"
          color="positive"
          label="APROVAÇÃO FINAL"
        />
      </section>
    </div>

    <!-- modais de confirmacao -->
    <DialogConfirmDesign
      :mensagem="modalRemover.mensagem"
      :exibir="modalRemover.exibir"
      :titulo="modalRemover.titulo"
      @resultado="handleRemover"
    />

    <DialogConfirmDesign
      :mensagem="modalContagem.mensagem"
      :exibir="modalContagem.exibir"
      :titulo="modalContagem.titulo"
      @resultado="handleContagem"
    />

    <DialogConfirmDesign
      :mensagem="modalEnviarContados.mensagem"
      :exibir="modalEnviarContados.exibir"
      :titulo="modalEnviarContados.titulo"
      @resultado="handleEnviarContados"
    />

    <DialogConfirmDesign
      :mensagem="modalFinalizar.mensagem"
      :exibir="modalFinalizar.exibir"
      :titulo="modalFinalizar.titulo"
      @resultado="handleFinalizar"
    />

    <DialogConfirmDesign
      :mensagem="modalAprovarRecontar.mensagem"
      :exibir="modalAprovarRecontar.exibir"
      :titulo="modalAprovarRecontar.titulo"
      @resultado="handleAprovarRecontar"
    />

    <DialogConfirmDesign
      :mensagem="modalAprovarSolicitar.mensagem"
      :exibir="modalAprovarSolicitar.exibir"
      :titulo="modalAprovarSolicitar.titulo"
      @resultado="handleAprovarSolicitar"
    />

    <DialogConfirmDesign
      :mensagem="modalRecontar.mensagem"
      :exibir="modalRecontar.exibir"
      :titulo="modalRecontar.titulo"
      @resultado="handleRecontar"
    />

    <DialogConfirmDesign
      :mensagem="modalAprovarDivergente.mensagem"
      :exibir="modalAprovarDivergente.exibir"
      :titulo="modalAprovarDivergente.titulo"
      @resultado="handleAprovarDivergente"
    />
  </section>
</template>

<script>
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, watch } from "vue";
import DialogConfirmDesign from "@/components/DialogConfirmDesign.vue";

const columns = [
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Codigo",
    field: "codigo",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "nome",
    label: "Descrição",
    field: "nome",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "endereco",
    label: "Endereço",
    field: "endereco",
    align: "left",
    style: "white-space: normal",
  },

  {
    name: "quantidade",
    label: "Quantidade",
    field: "quantidade",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "lote",
    label: "Lote",
    field: "lote",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "validade",
    label: "Validade",
    field: "validade",
    align: "left",
    style: "white-space: normal",
  },
];

export default {
  components: {
    DialogConfirmDesign,
  },
  props: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();
    const $q = useQuasar();
    const router = useRouter();
    const $route = useRoute();
    const id = $route.params.id;
    const inventario = ref("");
    const rows = ref([]);
    const disable = ref(true);
    const rows2 = ref([]);

    const getColumns2 = () => {
      const baseColumns = [
        {
          name: "codigo",
          label: "Codigo",
          field: "codigo",
          align: "left",
          style: "white-space: normal",
        },
        {
          name: "nome",
          label: "Descrição",
          field: "nome",
          align: "left",
          style: "white-space: normal",
        },
        {
          name: "amount",
          label: "Quantidade",
          field: "amount",
          align: "left",
          style: "white-space: normal",
        },
        {
          name: "lote",
          label: "Lote",
          field: "lote",
          align: "left",
          style: "white-space: normal",
        },
      ];

      if (
        inventario.value.status === "Finalizado" ||
        inventario.value.status === "Aprovado_divergente"
      ) {
        baseColumns.push(
          {
            name: "stocked",
            label: "Qtd. Sistema",
            field: "stocked",
            align: "left",
            style: "white-space: normal",
          },
          {
            name: "preco",
            label: "Dif. R$",
            field: (row) => {
              const amount = parseFloat(row.amount) || 0;
              const stocked = parseFloat(row.stocked) || 0;
              const price = parseFloat(row.preco) || 0;
              const difference = (amount - stocked) * price;

              return `R$ ${difference.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`;
            },
            align: "left",
            style: "white-space: normal",
          }
        );
      }

      baseColumns.push({
        name: "nome_usuario",
        label: "Contado Por	",
        field: "nome_usuario",
        align: "left",
        style: "white-space: normal",
      });

      return baseColumns;
    };

    const columns2Computed = ref([]);

    // refs para controle dos modais
    const produtoIdParaRemover = ref(null);

    const modalRemover = ref({
      exibir: false,
      titulo: "Confirmar Remoção",
      mensagem: "Deseja realmente remover este produto?",
    });

    const modalContagem = ref({
      exibir: false,
      titulo: "Confirmar Contagem",
      mensagem: "Deseja realmente finalizar a seleção e iniciar a contagem?",
    });

    const modalEnviarContados = ref({
      exibir: false,
      titulo: "Confirmar Envio",
      mensagem: "Deseja realmente enviar os itens contados?",
    });

    const modalFinalizar = ref({
      exibir: false,
      titulo: "Confirmar Finalização",
      mensagem:
        "Deseja realmente finalizar a contagem e enviar para aprovação?",
    });

    const modalAprovarRecontar = ref({
      exibir: false,
      titulo: "Confirmar Aprovação",
      mensagem: "Deseja aprovar e recontar os itens divergentes?",
    });

    const modalAprovarSolicitar = ref({
      exibir: false,
      titulo: "Confirmar Aprovação",
      mensagem: "Deseja aprovar e solicitar aprovação dos itens divergentes?",
    });

    const modalRecontar = ref({
      exibir: false,
      titulo: "Confirmar Recontagem",
      mensagem: "Deseja realmente solicitar uma recontagem?",
    });

    const modalAprovarDivergente = ref({
      exibir: false,
      titulo: "Confirmar Aprovação Final",
      mensagem: "Deseja realmente realizar a aprovação final?",
    });

    const getData = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        const response = await store.dispatch("inventario/getInventario", {
          id: id,
        });

        rows.value = response.data.result.produtos_conferencia;
        rows2.value = response.data.result.produtos;

        inventario.value = await response.data.result;
        disable.value = false;
        columns2Computed.value = getColumns2();
        emit("mudarStatus");
      } catch (error) {
        $q.notify({
          message: "Erro ao encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const confirmarRemover = (produtoId) => {
      produtoIdParaRemover.value = produtoId;
      modalRemover.value.exibir = true;
    };

    const handleRemover = async (confirmado) => {
      modalRemover.value.exibir = false;
      if (confirmado && produtoIdParaRemover.value) {
        await remover(produtoIdParaRemover.value);
        produtoIdParaRemover.value = null;
      }
    };

    const confirmarContagem = () => {
      modalContagem.value.exibir = true;
    };

    const handleContagem = async (confirmado) => {
      modalContagem.value.exibir = false;
      if (confirmado) {
        await contagem();
      }
    };

    const confirmarEnviarContados = () => {
      modalEnviarContados.value.exibir = true;
    };

    const handleEnviarContados = async (confirmado) => {
      modalEnviarContados.value.exibir = false;
      if (confirmado) {
        await enviarContados();
      }
    };

    const confirmarFinalizar = () => {
      modalFinalizar.value.exibir = true;
    };

    const handleFinalizar = async (confirmado) => {
      modalFinalizar.value.exibir = false;
      if (confirmado) {
        await finalizar();
      }
    };

    const confirmarAprovarRecontar = () => {
      modalAprovarRecontar.value.exibir = true;
    };

    const handleAprovarRecontar = async (confirmado) => {
      modalAprovarRecontar.value.exibir = false;
      if (confirmado) {
        await aprovar(true);
      }
    };

    const confirmarAprovarSolicitar = () => {
      modalAprovarSolicitar.value.exibir = true;
    };

    const handleAprovarSolicitar = async (confirmado) => {
      modalAprovarSolicitar.value.exibir = false;
      if (confirmado) {
        await aprovar(false);
      }
    };

    const confirmarRecontar = () => {
      modalRecontar.value.exibir = true;
    };

    const handleRecontar = async (confirmado) => {
      modalRecontar.value.exibir = false;
      if (confirmado) {
        await recontar();
      }
    };

    const confirmarAprovarDivergente = () => {
      modalAprovarDivergente.value.exibir = true;
    };

    const handleAprovarDivergente = async (confirmado) => {
      modalAprovarDivergente.value.exibir = false;
      if (confirmado) {
        await aprovarDivergente();
      }
    };

    const remover = async (id) => {
      let produto = [{ id: id }];
      try {
        await store.dispatch("inventario/removeProduto", {
          inventory_id: await inventario.value.uuid,
          products: produto,
        });

        $q.notify({
          message: "Produto removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getData();
      } catch (error) {
        $q.notify({
          message: "Erro ao remover produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const contagem = async () => {
      const uuidAtual = inventario.value.uuid;
      try {
        await store.dispatch("inventario/contagem", {
          inventory_id: uuidAtual,
        });

        $q.notify({
          message: "Contagem iniciada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        getData();
      } catch (error) {
        $q.notify({
          message: "Erro ao iniciar contagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const finalizar = async () => {
      const uuidAtual = inventario.value.uuid;
      try {
        await store.dispatch("inventario/finalizar", {
          inventory_id: uuidAtual,
        });

        $q.notify({
          message: "Finalizado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        getData();
      } catch (error) {
        $q.notify({
          message: "Erro ao finalizar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const aprovar = async (conferir) => {
      const uuidAtual = inventario.value.uuid;
      try {
        const response = await store.dispatch("inventario/aprovar", {
          inventory_id: uuidAtual,
          conferir_novamente: conferir,
        });

        let novoUuid = null;

        if (response?.data?.result?.uuid) {
          novoUuid = response.data.result.uuid;
        } else if (response?.data?.uuid) {
          novoUuid = response.data.uuid;
        } else if (response?.result?.uuid) {
          novoUuid = response.result.uuid;
        }

        if (novoUuid && novoUuid !== uuidAtual) {
          $q.notify({
            message:
              "Aprovado com sucesso! Redirecionando para o novo inventário...",
            color: "positive",
            timeout: 2000,
          });

          // redirecionar para o novo inventario criado
          setTimeout(() => {
            router
              .replace({
                name: "inventario-novo",
                params: { id: novoUuid },
              })
              .then(() => {
                window.location.reload();
              })
              .catch((error) => {
                console.error("Erro no redirecionamento:", error);
              });
          }, 1500);
        } else {
          $q.notify({
            message: "Aprovado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getData();
        }
      } catch (error) {
        console.error("Erro ao aprovar:", error);
        $q.notify({
          message: "Erro ao aprovar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const aprovarDivergente = async () => {
      const uuidAtual = inventario.value.uuid;
      try {
        await store.dispatch("inventario/aprovarDivergente", {
          inventory_id: uuidAtual,
        });

        $q.notify({
          message: "Aprovado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        getData();
      } catch (error) {
        $q.notify({
          message: "Erro ao aprovar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const recontar = async () => {
      const uuidAtual = inventario.value.uuid;
      try {
        await store.dispatch("inventario/recontar", {
          inventory_id: uuidAtual,
        });

        $q.notify({
          message: "Recontagem",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        getData();
      } catch (error) {
        $q.notify({
          message: "Erro ao tentar voltar para a recontagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarContados = async () => {
      let produtos = [];
      rows.value.forEach((e) => {
        if (!e.data_expiracao) {
          e.data_expiracao = "31/12/2022";
        }
        if (e.controla_lote == 1 && e.lote == undefined) {
          return;
        }
        if (e.amount == undefined) {
          return;
        }
        produtos.push(e);
      });

      const uuidAtual = inventario.value.uuid;
      try {
        await store.dispatch("inventario/enviarContados", {
          inventory_id: uuidAtual,
          products: produtos,
        });

        $q.notify({
          message: "Contagem iniciada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        getData();
      } catch (error) {
        $q.notify({
          message: "Erro ao iniciar contagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getData);

    const imprimir = async () => {
      const routeData = router.resolve({
        name: "inventario-imprimir",
        params: { id: id },
      });
      window.open(routeData.href, "_blank");
    };

    const imprimir2 = async () => {
      const routeData = router.resolve({
        name: "inventario-imprimir-contado",
        params: { id: id },
      });
      window.open(routeData.href, "_blank");
    };

    watch(
      () => props.atualizar,
      () => {
        getData();
      }
    );

    return {
      rows,
      columns,
      disable,
      remover,
      inventario,
      columns2Computed,
      rows2,
      contagem,
      enviarContados,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      finalizar,
      aprovar,
      recontar,
      aprovarDivergente,
      imprimir,
      imprimir2,
      filtrar: ref(""),
      filtrar2: ref(""),
      // modais
      modalRemover,
      modalContagem,
      modalEnviarContados,
      modalFinalizar,
      modalAprovarRecontar,
      modalAprovarSolicitar,
      modalRecontar,
      modalAprovarDivergente,
      // funcoes de confirmaçao
      confirmarRemover,
      handleRemover,
      confirmarContagem,
      handleContagem,
      confirmarEnviarContados,
      handleEnviarContados,
      confirmarFinalizar,
      handleFinalizar,
      confirmarAprovarRecontar,
      handleAprovarRecontar,
      confirmarAprovarSolicitar,
      handleAprovarSolicitar,
      confirmarRecontar,
      handleRecontar,
      confirmarAprovarDivergente,
      handleAprovarDivergente,
    };
  },
};
</script>

<style></style>
